/* Baci Service 12 — S12a: GJUHA E FALLBACK-UT (30 shtator 2026). Ngarkohet PAS baci-service-11.js, PARA baci.js.
   Regjistrohet te window.BaciServiceRules: fn(t, lang, raw, state) → { html, fallback: true } | null.
   "fallback" (e re, 2 rreshta te baci-service.js): shfaqet VETEM kur asnje rregull tjeter (as 'weak' i S11) s'ka pergjigje
   dhe mesazhi s'ka veture — pikerisht aty ku baci.js do te thoshte "Ma thuaj veturen dhe pjesen…" ne shqip.
   Tash klienti qe shkruan anglisht ose gjermanisht e merr te njejten fjali ne gjuhen e vet (R26), plus WhatsApp-in
   me tekst gati dhe orarin (R16 — kurre pyetje e vdekur). Shqipja mbetet te baci.js, e paprekur.

   Rregullat:
   - Vetem kur biseda s'ka veture te ruajtur (state.cars bosh) — "2019" ose "diffuser" pas nje veture mbetet vazhdim i bisedes.
   - Gjuha e fallback-ut matet PA termat teknike (bumper, diffuser, grill, lip, front, body kit…): klienti shqiptar qe
     shkruan vetem "front lip" ose "grill" merr shqip, jo anglisht. Fjali e tere pa asnje fjale te njohur → anglisht (R26).
   - Pjesa e permendur ("i need a front bumper") ruhet te state.part, si te baci.js, qe "g20 2021" pastaj ta gjeje parakolpin.
   - Shembujt jane ata qe Baci i lexon vertet: "front bumper for G20 2021", "diffuser for W205", "Stossstange für G20 2021", "Grill für W205".
   - Asnje cmim, afat ose premtim. Vetem FAKTI H: WhatsApp 048 770 400, e hene–e shtune deri ne 19:00. */
(function () {
  var U = window.BaciServiceUtil;
  if (!U || !window.BaciServiceRules) return;
  var has = U.has, waLink = U.waLink, detectLang = U.detectLang;
  var TEL_INT = '+383 48 770 400';
  /* termat teknike nuk jane shenje gjuhe */
  var TERMS = ['bumper', 'bumpers', 'diffuser', 'diffusor', 'grill', 'grille', 'lip', 'front', 'rear', 'body', 'kit', 'bodykit', 'spoiler', 'splitter',
    'conversion', 'set', 'led', 'original', 'abs', 'pp', 'maxton', 'design', 'whatsapp', 'ok', 'okay', 'm', 'amg', 'rs', 'gti', 'line', 'sport', 'black', 'gloss',
    'carbon', 'hood', 'fender', 'headlight', 'headlights', 'taillight', 'taillights', 'exhaust', 'skirts', 'side', 'tuning', 'auto', 'fit', 'fits', 'part', 'parts', 'car'];
  var KEEP_EN = ['i need', 'i want', 'do you', 'looking for', 'my car', 'for my', 'parts for', 'a part'];

  function fbLang(t) {
    var i, w = t.split(' '), rest = [];
    for (i = 0; i < KEEP_EN.length; i++) if (has(t, KEEP_EN[i])) return detectLang(t);
    for (i = 0; i < w.length; i++) if (TERMS.indexOf(w[i]) < 0 && !/^\d+$/.test(w[i])) rest.push(w[i]);
    if (!rest.length) return 'sq';
    return detectLang(rest.join(' '));
  }

  var T = {
    en: {
      body: 'Tell me your <b>car and the part</b> — e.g. "front bumper for G20 2021" or "diffuser for W205". From the model and the year I find the parts made for your car. You can also ask me about shipping, returns, painting, payment or opening hours.',
      tail: ' Prefer a person? The team replies on WhatsApp: <b>' + TEL_INT + '</b> (Monday–Saturday until 19:00).',
      wa: 'Hello, I\'m looking for a part for my car.', waLabel: 'Message the team on WhatsApp'
    },
    de: {
      body: 'Nenn mir dein <b>Auto und das Teil</b> — z. B. „Stossstange für G20 2021“ oder „Grill für W205“. Über Modell und Baujahr finde ich die Teile, die für dein Auto gemacht sind. Du kannst mich auch zu Versand, Rückgabe, Lackierung, Zahlung oder Öffnungszeiten fragen.',
      tail: ' Lieber ein Mensch? Das Team antwortet auf WhatsApp: <b>' + TEL_INT + '</b> (Montag–Samstag bis 19:00).',
      wa: 'Hallo, ich suche ein Teil für mein Auto.', waLabel: 'Dem Team auf WhatsApp schreiben'
    }
  };

  window.BaciServiceRules.push(function (t, lang, raw, state) {
    try {
      if (state && state.cars && state.cars.length) return null;
      var fl = fbLang(t), x = T[fl];
      if (!x) return null; /* shqip → baci.js */
      try { var p = window.BaciParse ? window.BaciParse(raw) : null; if (p && p.part && state) state.part = p.part; } catch (e1) {}
      return { html: x.body + x.tail + '<p class="bacinext">' + waLink(x.wa, x.waLabel) + '</p>', fallback: true };
    } catch (e) { return null; }
  });
  window.BaciFallbackLang = fbLang;
  window.BACI_SERVICE12_READY = true;
})();
